/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Model from '@tripian/model';
import { Check, Edit, Trash, Users } from '../base/Svg/Icons';
import PreLoading from '../base/PreLoading/PreLoading';
import classes from './UserCompanions.scss';
import Button from '../base/Button/Button';

interface IUserCompanions {
  companions: Model.Companion[];
  companionLoadingList: Array<number>;
  deleteCompanion: (id: number) => void;
  editCompanion: (companion: Model.Companion) => void;
  addCompanion: (companion: Model.Companion) => void;
  showWarningMessage: (show: boolean) => void;
  onEditClick: (companion: Model.Companion) => void;
  onAddClick: () => void;
  t: (value: Model.TranslationKey) => string;
}

const UserCompanions: React.FC<IUserCompanions> = ({ companions, companionLoadingList, deleteCompanion, showWarningMessage, onEditClick, onAddClick, t }) => {
  const handleDeleteCompanion = (companion: Model.Companion) => {
    if (companion.memberOfTrip) {
      showWarningMessage(true);
    } else {
      showWarningMessage(false);
      deleteCompanion(companion.id);
    }
  };

  return (
    <div className={classes.container}>
      <div className="row">
        <div className={`col col12 ${classes.headerWrapper}`}>
          <div className={classes.headerTitle}>{t('user.travelCompanions.title')}</div>
          <Button text={t('add_companion' as Model.TranslationKey)} color="primary" onClick={onAddClick} className={classes.addButton} />
        </div>
      </div>

      <div className={classes.companionList}>
        {companions.map((companion) => (
          <div key={companion.id} className={classes.companionItem}>
            {companionLoadingList.includes(companion.id) ? (
              <div className={classes.loadingWrapper}>
                <PreLoading />
              </div>
            ) : (
              <div className={classes.content}>
                <div className={classes.header}>
                  <div className={classes.info}>
                    <div className={classes.field}>
                      <label>{t('user.travelCompanions.companionTitle')}</label>
                      <p className={classes.value}>{companion.title}</p>
                    </div>
                    <div className={classes.field}>
                      <label>{t('user.travelCompanions.companionName')}</label>
                      <p className={classes.value}>{companion.name}</p>
                    </div>
                    <div className={classes.field}>
                      <label>{t('user.travelCompanions.companionAge')}</label>
                      <p className={classes.value}>{companion.age}</p>
                    </div>
                  </div>
                  <div className={classes.actions}>
                    <button type="button" onClick={() => onEditClick(companion)} className={classes.editButton}>
                      <Edit stroke="#4b5563" />
                    </button>
                    <button type="button" onClick={() => handleDeleteCompanion(companion)} className={classes.deleteButton}>
                      <Trash stroke="#ef4444" />
                    </button>
                  </div>
                </div>
                <div className={classes.dietaryRestrictions}>
                  <label>Dietary Restrictions</label>
                  <div className={classes.tags}>
                    {companion.answers.includes(1) && (
                      <div className={classes.tag}>
                        <Check />
                        <span>Vegetarian</span>
                      </div>
                    )}
                    {companion.answers.includes(2) && (
                      <div className={classes.tag}>
                        <Check />
                        <span>Vegan</span>
                      </div>
                    )}
                    {companion.answers.includes(41) && (
                      <div className={classes.tag}>
                        <Check />
                        <span>Gluten Free</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}

        {companions.length === 0 && (
          <div className={classes.emptyState}>
            <div className={classes.iconWrapper}>
              <Users />
            </div>
            <h3 className={classes.title}>No Companions Yet</h3>
            <p className={classes.description}>Add your first travel companion to get started.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserCompanions;
